import SecureBaseModel from './SecureBaseModel';

class SSRModel extends SecureBaseModel { //SSR - Stripe Subscription Record

    //These have to match with the routes in backend > APIController
    static SSR_SUBSCRIPTION_INFO = 'ssr-subscription-info';
    static SSR_SUBSCRIPTION_DETAIL = 'ssr-subscription-detail';
    static SSR_PROBLEMATIC_LIST = 'ssr-problematic-list';
    static SSR_PROBLEMATIC_UPDATE = 'ssr-problematic-update';
    static SSR_ENABLED = 'ssr-enabled';

    constructor() {
        super();
    }

    // params { userId: value, sessionId: value, csOrderNo: value, infoRequestType: value }
    async getSubscriptionInfo(params) {
        return await this.postData(SSRModel.SSR_SUBSCRIPTION_INFO, params);
    }

    // params { userId: value, sessionId: value, subscriptionId: value, infoRequestType: value }
    async getSubscriptionDetail(params) {
        return await this.postData(SSRModel.SSR_SUBSCRIPTION_DETAIL, params);
    }

    // params { userId: value, sessionId: value, subscriptionId: value, infoRequestType: value }
    async getProblematicRecords(params) {
        return await this.postData(SSRModel.SSR_PROBLEMATIC_LIST, params);
    }

    // params { userId: value, sessionId: value, subscriptionId: value, infoRequestType: value }
    async updateProblematicRecord(params) {
        return await this.postData(SSRModel.SSR_PROBLEMATIC_UPDATE, params);
    }

    // params { userId: value, sessionId: value }
    async ssrEnabled(params) {
        return await this.postData(SSRModel.SSR_ENABLED, params);
    }
}

export default SSRModel;
